import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

interface ResolvePendingActivationRequestBody {
  activationID: string;
  appID: string;
  businessID: string;
  approved: boolean;
  addonID?: string;
  accountID?: string;
  rejectedReason?: string;
}

const resolvePendingActivationRoute = `/ajax/marketplace/resolve-activation`;

@Injectable()
export class PendingAccountsService {
  constructor(private http: HttpClient) {}

  resolvePendingActivation(
    activationID: string,
    appID: string,
    businessID: string,
    approved: boolean,
    addonID?: string,
    accountID?: string,
    rejectionReason?: string,
  ): Observable<object> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
    const body = {
      activationID,
      appID,
      businessID,
      approved,
      addonID,
      accountID,
      rejectionReason,
    } as ResolvePendingActivationRequestBody;

    return this.http.post(resolvePendingActivationRoute, JSON.stringify(body), httpOptions);
  }
}
